module.exports = __webpack_public_path__ + "static/media/tachometer-fast.cdc685dc.svg";